import { render, staticRenderFns } from "./PayPalFeeImport.vue?vue&type=template&id=7c8e5e04"
import script from "./PayPalFeeImport.vue?vue&type=script&lang=js"
export * from "./PayPalFeeImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports